export default "__VITE_ASSET__qD2a_MmB__"